import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoadingUI from "./components/desktop/common/LoadingUI";
import ScrollToTop from "./utils/ScrollToTop";
import useDeviceType from "./utils/useDeviceType";
import { setVh } from "./utils/setVh";
import { BASENAME, DEV_ENTRY_PATH_REGEX } from "@/constants/event";
import { isDevMode } from "@/constants/env";
import { FinishProvider, FinishGuard } from "@/provider/FinishProvider";
// import GoogleTagManager from "./utils/GoogleTagManager";
// import useGtmPageView from "./utils/useGtmPageView";

const MainLayout = lazy(() => import("@/layouts/MainLayout"));
const HomeLayout = lazy(() => import("@/layouts/HomeLayout"));
const TracksLayout = lazy(() => import("@/layouts/TracksLayout"));
const EventLayout = lazy(() => import("@/layouts/EventLayout"));
const FaqLayout = lazy(() => import("@/layouts/FaqLayout"));
const PreviousLayout = lazy(() => import("@/layouts/PreviousLayout"));
const RegisterLayout = lazy(() => import("@/layouts/RegisterLayout"));
const NotFound = lazy(() => import("@/layouts/NotFoundLayout"));

// 값은 @/constants/env 에 있다 (순환 import 방지). 여기서는 다시 내보내기만 한다.
export { isDevMode };

function App() {
  // 디바이스 타입과 viewport 높이를 전역 UI 기준으로 동기화
  useDeviceType();
  // useGtmPageView();

  // 개발 버전 접근 제어 플래그
  const currentUrl = new URL(window.location.href);
  const isTargetHost = /(^|\.)squp\.kr$/i.test(currentUrl.hostname);
  const isDevEntryPath = DEV_ENTRY_PATH_REGEX.test(currentUrl.pathname);
  const isDevQuery = currentUrl.searchParams.get("mode") === "dev";
  const shouldRestrictDevAccess = isDevMode && isTargetHost;
  const isDevAccessAllowed =
    !shouldRestrictDevAccess || (isDevEntryPath && isDevQuery);

  useEffect(() => {
    setVh();
    window.addEventListener("resize", setVh);
    return () => window.removeEventListener("resize", setVh);
  }, []);

  useEffect(() => {
    if (!isDevAccessAllowed) {
      window.location.replace("https://squp.kr");
    }
  }, [isDevAccessAllowed]);

  if (!isDevAccessAllowed) {
    return null;
  }

  const isSamsungBrowser = /SamsungBrowser/i.test(navigator.userAgent);
  if (isSamsungBrowser) {
    alert(
      "삼성 브라우저에서 자동 다크모드가 적용되어 색상이 왜곡될 수 있습니다. \n Chrome 등 다른 브라우저 사용을 권장합니다.",
    );
  }

  return (
    <>
      {/* <GoogleTagManager gtmId="GTM-KK24G4XW" /> */}
      <FinishProvider>
        <BrowserRouter basename={BASENAME}>
          <ScrollToTop />
          {/* <LoadingUI /> */}
          <Suspense fallback={<LoadingUI />}>
            {/* 페이지별 레이아웃 라우팅 */}
            <Routes>
              <Route path="/" element={<MainLayout />}>
                <Route index element={<HomeLayout />} />
                {/* <Route path="/about" element={<AboutLayout title="ABOUT" />} /> */}
                <Route
                  path="/tracks"
                  element={<TracksLayout title="TRACKS" />}
                />
                <Route path="/event" element={<EventLayout title="EVENT" />} />
                <Route path="/faq" element={<FaqLayout title="FAQ" />} />
                <Route
                  path="/previous"
                  element={<PreviousLayout title="PREVIOUS" />}
                />
                {/* 행사 종료(FINISH_AT) 이후에는 참가신청 경로를 404 로 응답한다 */}
                <Route
                  path="/register"
                  element={
                    <FinishGuard fallback={<NotFound />}>
                      <RegisterLayout title="REGISTER" />
                    </FinishGuard>
                  }
                />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </Suspense>
        </BrowserRouter>
      </FinishProvider>
    </>
  );
}

export default App;
